import React from "react";
import styled from "styled-components";
import { colors } from "../../Assets/styles/colors";
import { useTranslate, useTolgee } from '@tolgee/react';
import { useAuthService } from "../../Context/AuthContext";
import { displayAvatar } from "../../Helpers/chatHelper/AvatarHelper";
import { displayName } from "../../Helpers/chatHelper/NameHelper";
import { findTranslatedTextForUser } from "../../Helpers/chatHelper/ChatHelper";
import { ReactComponent as DraftIcon } from "../../Assets/iconsv2/chatContextmenu/edit.svg";

const ChatListElement = ({
  handleSelectConversation,
  data,
  selected,
  displayMenu,
  hasDraftMessage,
  getDraftMessage,
  hasReplyState,
  getReplyState,
}) => {
  const { user } = useAuthService();
  const { t } = useTranslate();
  const tolgee = useTolgee();
  const handleLastMessage = (last_message) => {

    if (data?.unread_messages_ids?.length > 0) {
      if (!last_message) {
        return;
      }
      
      if (last_message.image) {
        return t('chat.image');
      }
      if (last_message.document) {
        return t('chat.file');
      }
      if (last_message.video) {
        return t('general.video');
      }
      
      let translatedForCurrentUser = findTranslatedTextForUser(
        last_message.message_translations,
        user
      );
      
      if (!data?.group) {
        if (last_message.deleted) {
          return t('chat.message_deleted');
        }
        return translatedForCurrentUser?.translation;
      } else {
        if (last_message.deleted) {
          return `~ ${last_message.user?.name}: ` + t('chat.message_deleted');
        }
        if (last_message.user) {
          return `~ ${last_message.user?.name}: ` + translatedForCurrentUser?.translation;
        }
      }
      
      return translatedForCurrentUser?.translation;
    }

    if (hasReplyState(data.id)) {
      const replyState = getReplyState(data.id);
      return replyState.replyText;
    }

    if (hasDraftMessage(data.id)) {
      const draftMessage = getDraftMessage(data.id);
      return draftMessage;
    }

    if (!last_message) {
      return;
    }
    
    if (last_message.image) {
      return t('chat.image');
    }
    if (last_message.document) {
      return t('chat.file');
    }
    if (last_message.video) {
      return t('general.video');
    }
    
    let translatedForCurrentUser = findTranslatedTextForUser(
      last_message.message_translations,
      user
    );
    
    if (!data?.group) {
      if (last_message.deleted) {
        return t('chat.message_deleted');
      }
      return translatedForCurrentUser?.translation;
    } else {
      if (last_message.deleted) {
        return `~ ${last_message.user?.name}: ` + t('chat.message_deleted');
      }
      if (last_message.user) {
        return `~ ${last_message.user?.name}: ` + translatedForCurrentUser?.translation;
      }
    }
  };

  const displayNewOrTimeAgo = (last_message) => {
    if (data?.unread_messages_ids?.length > 0) {
      if (!last_message || !last_message.id) {
        return;
      }

      const translationForCurrentUser = findTranslatedTextForUser(
        last_message.message_translations,
        user
      );

      if (last_message) {
        const formatRelativeTime = (date) => {
          if (!date) return null;

          const now = new Date();
          const messageDate = new Date(date);

          if (isNaN(messageDate.getTime())) return null;
          
          const diffInSeconds = Math.floor((now - messageDate) / 1000);

          const currentLanguage = tolgee.getLanguage() || 'en';
          const rtf = new Intl.RelativeTimeFormat(currentLanguage, { numeric: 'auto' });

          if (diffInSeconds < 60) {
            return rtf.format(-diffInSeconds, 'second');
          } else if (diffInSeconds < 3600) {
            return rtf.format(-Math.floor(diffInSeconds / 60), 'minute');
          } else if (diffInSeconds < 86400) {
            return rtf.format(-Math.floor(diffInSeconds / 3600), 'hour');
          } else if (diffInSeconds < 2592000) {
            return rtf.format(-Math.floor(diffInSeconds / 86400), 'day');
          } else if (diffInSeconds < 31536000) {
            return rtf.format(-Math.floor(diffInSeconds / 2592000), 'month');
          } else {
            return rtf.format(-Math.floor(diffInSeconds / 31536000), 'year');
          }
        };

        return (
          <div style={{
            color: "rgba(150, 156, 161, 1)",
            fontSize: "12px",
            whiteSpace: "nowrap",
          }}>
            {formatRelativeTime(translationForCurrentUser?.created_at)}
          </div>
        );
      }
      return;
    }

    if (hasDraftMessage && hasDraftMessage(data.id)) {
      return null;
    }

    if (!last_message || !last_message.id) {
      return;
    }

    const translationForCurrentUser = findTranslatedTextForUser(
      last_message.message_translations,
      user
    );

    if (
      last_message &&
      last_message.user_id != user.id &&
      !translationForCurrentUser?.read_at
    ) {
    } else {
      if (last_message) {
        const formatRelativeTime = (date) => {
          if (!date) return null;

          const now = new Date();
          const messageDate = new Date(date);

          if (isNaN(messageDate.getTime())) return null;

          const diffInSeconds = Math.floor((now - messageDate) / 1000);

          const currentLanguage = tolgee.getLanguage() || 'en';
          const rtf = new Intl.RelativeTimeFormat(currentLanguage, { numeric: 'auto' });

          if (diffInSeconds < 60) {
            return rtf.format(-diffInSeconds, 'second');
          } else if (diffInSeconds < 3600) {
            return rtf.format(-Math.floor(diffInSeconds / 60), 'minute');
          } else if (diffInSeconds < 86400) {
            return rtf.format(-Math.floor(diffInSeconds / 3600), 'hour');
          } else if (diffInSeconds < 2592000) {
            return rtf.format(-Math.floor(diffInSeconds / 86400), 'day');
          } else if (diffInSeconds < 31536000) {
            return rtf.format(-Math.floor(diffInSeconds / 2592000), 'month');
          } else {
            return rtf.format(-Math.floor(diffInSeconds / 31536000), 'year');
          }
        };

        return (
          <div style={{
            color: "rgba(150, 156, 161, 1)",
            fontSize: "12px",
            whiteSpace: "nowrap",
          }}>
            {formatRelativeTime(translationForCurrentUser?.created_at)}
          </div>
        );
      }
    }
  };

  const shouldShowUnreadCounter = () => {
    return data?.unread_messages_ids?.length > 0;
  };

  const shouldShowDraftIcon = () => {
    return data?.unread_messages_ids?.length === 0 && 
           (hasDraftMessage(data.id) || hasReplyState(data.id));
  };

  return (
    <ChatListElementContainer
      onClick={() => handleSelectConversation(data)}
      selected={selected}
      $closeQc={!data.open && data.quick_chat}
      $isCallChat={data.is_call_chat}
      onContextMenu={(e) => displayMenu(e, data)}
    >
      <UserAvatar style={data.quick_chat ? { border: "none" } : {}}>
        {displayAvatar(data)}
      </UserAvatar>

      <Text>
        <PhoneNumber>
          <h1>{displayName(data)}</h1>
          {displayNewOrTimeAgo(data.last_message)}
        </PhoneNumber>
        <Message>
          <MessageContent $isDraft={shouldShowDraftIcon()}>
            {shouldShowDraftIcon() && (
              <DraftIconWrapper>
                <DraftIcon />
              </DraftIconWrapper>
            )}
            <p>{handleLastMessage(data.last_message)}</p>
          </MessageContent>
          {shouldShowUnreadCounter() && (
            <UnreadCounter>
              <h2>
                {data.unread_messages_ids.length > 99
                  ? `+99`
                  : data.unread_messages_ids.length}
              </h2>
            </UnreadCounter>
          )}
        </Message>
      </Text>
    </ChatListElementContainer>
  );
};

export default ChatListElement;

const ChatListElementContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 13px 16px;
  background: ${({ theme, selected }) =>
    selected ? theme.chat.selectedBackground : theme.menu.background};
  gap: 16px;
  opacity: ${(props) => (props.$closeQc ? "0.5" : "")};

  &:hover {
    background: ${({ theme }) => theme.chat.selectedBackground};
  }
`;

const UserAvatar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  justify-content: center;
  background: ${({ selected, theme }) =>
    selected ? theme.sidebar.selectedBtnBackground : "transparent"};
  color: ${({ selected, theme }) =>
    selected ? theme.sidebar.selectedIconColor : theme.sidebar.iconColor};
  min-width: 42px;
  min-height: 42px;
  max-height: 42px;
  max-width: 42px;
  width: 42px;
  height: 42px;
  svg {
    width: 42px;
    height: 42px;
  }

  img {
    border-radius: 100px;
    border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
    object-fit: cover;
    position: relative;
    height: 42px;
    width: 42px;
  }
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
  width: 100%;
`;

const PhoneNumber = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  h1 {
    color: ${({ theme }) => theme.menu.primaryTextColor};
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.04px;
    vertical-align: middle;
  }

  h2 {
    color: ${({ theme }) => theme.menu.primaryTextColor};
    font-weight: 500;
    font-size: 16px;
    line-height: 100%;
    letter-spacing: 0.04px;
    text-align: left;
  }
`;

const Message = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const MessageContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  overflow: hidden;

  p {
    width: 100%;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    white-space: wrap;
    text-overflow: ellipsis;
    color: ${({ theme, $isDraft }) => 
      $isDraft ? theme.menu.primaryTextColor : theme.chat.elementSecondaryColor};
    font-size: 16px;
    font-weight: ${({ $isDraft }) => $isDraft ? 500 : 500};
    line-height: 24px;
    text-align: left;
    font-style: ${({ $isDraft }) => $isDraft ? 'italic' : 'normal'};
    overflow: hidden;
  }
`;

const DraftIconWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  
  svg {
    width: 14px;
    height: 14px;
    color: ${({ theme }) => theme.menu.primaryTextColor};
    opacity: 0.7;
  }
`;

const UnreadCounter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  overflow: hidden;
  border-radius: 100px;
  background: ${({ theme }) => theme.menu.selectedTextColor};

  h2 {
    color: ${({ theme }) => theme.unreadCounter.color};
    font-family: Inter;
    font-weight: 600;
    font-size: 10px;
    line-height: 10px;
    letter-spacing: 0px;
    text-align: center;
  }
`;
